import ProxyBase from '../../../../core/proxies/ProxyBase'

class OwnershipAndGroupProxy extends ProxyBase {
  getHighlights(params) {
    return this.get('Hightlight', params)
  }
  getOwnershipDetail(params) {
    return this.get('OwnershipDetails', params)
  }
  getOwnershipHistorical(params) {
    return this.get('OwnershipHistorical', params)
  }
  getRelatedCompanyViewBy(params) {
    return this.get('OwnershipRelatedDetails', params)
  }
  downloadStructureMajorShareholder(params) {
    return this.get('StructureMajorShareholders/Export', params, 'download')
  }
  downloadParentCompany(params) {
    return this.get('ParrentCompany/Export', params, 'download')
  }
  downloadBranch(params) {
    return this.get('Branches/Export', params, 'download')
  }
  downloadAssociatedCompany(params) {
    return this.get('AssociatedCompany/Export', params, 'download')
  }
  downloadSubsidiary(params) {
    return this.get('Subsidiaries/Export', params, 'download')
  }
  downloadRelatedCompany(params) {
    return this.get('OwnershipRelatedDetails/Export', params, 'download')
  }
}

export default new OwnershipAndGroupProxy('OwnershipAndGroup/')
